export default __webpack_public_path__ + "static/media/arrowBack.f804e256.svg";